import { AuthService, OAuthStorage } from 'src/app/auth';
import { Component, Inject, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { NewUserComponent } from 'src/app/modules/user-management/components/new-user/new-user.component';
import { CommonWindow } from '@interfaces';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IncidenceService } from 'src/app/modules/incidents/services/incidents.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: [ './menu.component.scss' ]
})
export class MenuComponent implements OnInit, OnChanges, OnDestroy {
  private destroyed$: Subject<boolean> = new Subject<boolean>();
  public language = '';
  public open = false;
  public suffixComponent = '';
  public isExternal: boolean;
  public isConsultaSips: boolean;
  public hasAccessToSettlement = false;
  public isLoading = false;
  public casesNotifications = 0;
  public isUserSpanish = true;
  public country = '';

  @Input() isOpen = false;

  constructor(
    @Inject(I18NEXT_SERVICE) private i18NextService: ITranslationService,
    private auth: AuthService,
    private dialog: MatDialog,
    private authStorage: OAuthStorage,
    private incidenceService: IncidenceService,
    @Inject('Window') protected window: CommonWindow
  ) {
    this.suffixComponent = auth.getRole().suffix;
  }

  ngOnInit(): void {
    this.isUserSpanish = this.auth.getUserData().country === 'ES';
    this.isExternal = this.auth.getRole().suffix === '-pymes';
    this.isConsultaSips = this.auth.getUserData().consultaSips; 
    this.i18NextService.events.languageChanged.subscribe(res => {
      this.language = res === 'es-ES' ? 'LANGUAGE.SPANISH' : 'LANGUAGE.PORTUGUESE';
    });
    this.hasAccessToSettlement = this.auth.getUserData().hasAccessToSettlement;
    this.country = this.authStorage.getItem('country');
    this.getNotificationsCases();
    this.updateCasesNotifications();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.toggle(changes.isOpen.currentValue);
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  public toggle(value: boolean): void {
    this.open = value;
  }

  public openNewUserDialog(): void {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = {
      disableClose: true,
      autoFocus: false,
      panelClass: [ 'modal__full-screen' ]
    };

    this.dialog.open(NewUserComponent, dialogConfig.data);
  }

  public navigateSap(): void {
    window.open('https://1671.callidusondemand.com/saml2/sp/acs/post', '_blank');
  }

  private updateCasesNotifications(): void {
    this.incidenceService.casesNotifications.pipe(takeUntil(this.destroyed$)).subscribe(
      res => {
        if (res) {
          this.casesNotifications = res?.totalNotificaciones ? res?.totalNotificaciones : 0;
        }
      }
    );
  }

  private getNotificationsCases(): void {
    this.incidenceService.getNotificationsCases().pipe(takeUntil(this.destroyed$)).subscribe(
      res => {
        if (res) {
          this.incidenceService.casesNotifications.next(res.data);
        }
      }
    );
  }
}
